/**
 * FILEPATH: /c:/codebase/AIA/Knowledge.AI-AWS/frontend/src/pages/CreateUserPage.tsx
 *
 * This file contains the implementation of the CreateUserPage component.
 * The component is responsible for rendering a form to create a new user.
 * It includes form fields for username, description, email, password, and department.
 * The component also fetches project information and allows the user to select projects.
 * When the form is submitted, it sends a request to create a new user with the provided information.
 *
 * @packageDocumentation
 */
import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { useEffect, useRef, useState } from 'react';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
// @mui
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Container, Stack, Typography, Card } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import { InputAdornment, IconButton } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Theme, useTheme } from '@mui/material/styles';
import { EmailOutlined } from '@mui/icons-material';
import ls from 'localstorage-slim';
import { Toast } from 'primereact/toast';
import { Link } from 'react-router-dom';
import * as CryptoJS from 'crypto-js';
import { Show } from '@chakra-ui/react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { green } from '@mui/material/colors';

// ----------------------------------------------------------------------
interface dropdown {
  label: string;
  value: string;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

/**
 * Returns the styles for a given name based on the project name and theme.
 * @param name - The name to get styles for.
 * @param ProjectName - An array of project names.
 * @param theme - The theme object.
 * @returns The styles object.
 */
function getStyles(name: string, ProjectName: readonly string[], theme: Theme) {
  return {
    fontWeight:
      ProjectName.indexOf(name) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,
  };
}

/**
 * Represents the ProductsPage component.
 * This component is responsible for rendering the page for creating new users.
 */
export default function ProductsPage() {
  // State for form fields
  const [userName, setUserName] = useState('');
  const [newuserName, setNewUserName] = useState('');
  const [description, setDescription] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmpassword, setConfirmPassword] = useState('');

  const departmentName: dropdown[] = [
    // { label: 'Big Data', value: 'Big Data' },
    // { label: 'AI/ML', value: 'AI/ML' },
    // { label: 'Salesforce', value: 'Salesforce' },
    { label: 'PMR', value: 'PMR' },
  ];

  const role: dropdown[] = [
    { label: 'Admin', value: 'admin' },
    { label: 'User', value: 'user' },
  ];

  const [selectedDepartment, setSelectedDepartment] = React.useState(departmentName[0].value);
  const [selectedRole, setSelectedRole] = React.useState(role[1].value);
  const handleChange = (event: SelectChangeEvent) => {
    setSelectedDepartment(event.target.value as string);
  };

  const handleChangeRole = (event: SelectChangeEvent) => {
    setSelectedRole(event.target.value as string);
  };

  const theme = useTheme();
  var [projectsDetails, setProjectsDetails] = React.useState([]);
  const [ProjectName, setProjectName] = React.useState<string[]>([]);
  var project_index_mapping = null;
  var projlist = [];
  var [project, setProject] = React.useState('');
  var [projectIndex, setProjectIndex] = React.useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [formValid, setFormValid] = useState(false);
  const [departmentError, setDepartmentError] = useState('');
  const [roleError, setRoleError] = useState('');
  const [projectsError, setProjectsError] = useState('');
  const [projectNames, setProjectNames] = useState([]);
  const [usernameError, setUsernameError] = useState('');
  var projectmenulist = [{ label: 'None', value: 'None' }];

  useEffect(() => {
    const load_project_info = async () => {
      const user_data = ls.get('token-gpt-app');

      //@ts-ignore
      if (user_data && user_data['email']) {
        //@ts-ignore
        var uname = user_data['email'].split('@')[0];
        setUserName(uname);

        // Comment below statement after testing
        // uname = 'tluser'

        fetch(process.env.REACT_APP_PROJECT_INFO_URL || '', {
          method: 'POST',
          body: JSON.stringify({ user: uname }),
        })
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            // Use the data from the response
            // console.log(data);
            //@ts-ignore
            project_index_mapping = data.reduce((acc, item) => {
              // if(item.ProjectName != 'supreme_lending'){

              // Extract "ProjectName" and "IndexName" from each item
              const { ProjectName, IndexName } = item;

              // Create the key-value pair in the accumulator
              acc[ProjectName] = IndexName;

              return acc;
              // }
            }, {});
            // console.log('project index mapping : ', project_index_mapping);
            projlist = Object.keys(project_index_mapping);
            // console.log('KEYS in project index mapping : ', projlist);

            //check if ProjectName exists in the mapping

            // if(project_index_mapping.includes('supreme_lending')){
            //   delete project_index_mapping['supreme_lending']
            // }
            // @ts-ignore
            projectmenulist = Object.entries(project_index_mapping).map(([key, value]) => ({
              label: key,
              value: value,
            }));

            // projectmenulist.unshift({label:"None", value:"None"})

            // console.log('projindmap : ', projectmenulist);
            //@ts-ignore
            setProjectsDetails(projectmenulist);
            // console.log('VALUES in project index mapping : ', Object.values(project_index_mapping));
          })
          .catch((err) => {
            console.log(err.message);
          });
      }
    };
    load_project_info();
    // const load_info = async() => {
    //   await get_chat_info(1, "knowledge_ai", "tluser")
    // }
    // load_info()
  }, []);

  /**
   * Handles the change event of the project name select input.
   *
   * @param {SelectChangeEvent<typeof ProjectName>} event - The change event object.
   */
  const handleProjectChange = (event: SelectChangeEvent<typeof ProjectName>) => {
    const {
      target: { value },
    } = event;

    // // @ts-ignore
    // setProjectNames(typeof value === 'string' ? value.split(',') : value);
    // setProjectName(
    //   // On autofill we get a stringified value.
    //   typeof value === 'string' ? value.split(',') : value
    // );
    // Handle string or array of project names
    const selectedProjects = typeof value === 'string' ? value.split(',') : value;

    // Map the project names to index names using projectsDetails
    //@ts-ignore
    const indexNames = selectedProjects.map((projectName) => {
      // @ts-ignore
      const projectDetail = projectsDetails.find((detail) => detail.label === projectName);
      // @ts-ignore
      return projectDetail ? projectDetail.value : null;
    });

    // @ts-ignore
    setProjectNames(indexNames);
    setProjectName(selectedProjects);
  };
  const toast = useRef<Toast>(null);
  /**
   * Displays a success toast message.
   *
   * @param text - The text to be displayed in the toast message.
   */
  const showSuccess = (text: string) => {
    toast.current?.show({ severity: 'success', summary: 'Success', detail: text, life: 3000 });
  };

  const showInfo = (text: string) => {
    toast.current?.show({ severity: 'info', summary: 'Info', detail: text, life: 3000 });
  };

  const showWarn = (text: string) => {
    toast.current?.show({ severity: 'warn', summary: 'Warning', detail: text, life: 3000 });
  };

  const showError = (text: string) => {
    toast.current?.show({ severity: 'error', summary: 'Error', detail: text, life: 3000 });
  };

  /**
   * Creates a new user by sending a POST request to the server.
   * If the form is valid, it sends the user data to the server and handles the response.
   */
  const createUser = async () => {
    if (formValid) {
      const url =
        //"http://localhost:7072/api/create_user"
        process.env.REACT_APP_CREATE_USER || '';
      const hashedPassword = CryptoJS.SHA256(password).toString(CryptoJS.enc.Hex);
      const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          firstname: newuserName,
          lastname: newuserName,
          email: email,
          department: selectedDepartment,
          password: hashedPassword,
          proj_list: projectNames,
          role: selectedRole,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response != null && response.status == 200) {
        showSuccess('User Created Successfully');
      } else {
        showError('Error in Creating User. Please try again.');
      }
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event: any) => {
    event.preventDefault();
  };

  const validateEmail = (email: string) => {
    // Regular expression for email validation
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  /**
   * Validates the selected department.
   * If no department is selected, sets the department error message.
   * Otherwise, clears the department error message.
   * Also calls the validateForm function.
   */
  const validateDepartment = () => {
    if (!selectedDepartment) {
      setDepartmentError('Please select a department');
    } else {
      setDepartmentError('');
    }
    validateForm();
  };

  const validateRole = () => {
    if (!selectedRole) {
      setRoleError('Please select a role');
    } else {
      setRoleError('');
    }
    validateForm();
  };

  /**
   * Validates the projects and sets the projects error message if no project is selected.
   * Also calls the validateForm function.
   */
  const validateProjects = () => {
    // console.log('ProjectNames : ', projectNames);
    if (projectNames.length === 0) {
      setProjectsError('Please select at least one project');
    } else {
      setProjectsError('');
    }
    validateForm();
  };

  /**
   * Validates the user name and sets the username error if it is empty.
   * Also calls the validateForm function.
   */
  const validateUserName = () => {
    if (!newuserName) {
      setUsernameError('Please enter a username');
    } else {
      setUsernameError('');
    }
    validateForm();
  };

  /**
   * Validates the strength of a password.
   * @param password - The password to be validated.
   * @returns The strength of the password ('strong', 'medium', or 'weak').
   */
  const validatePasswordStrength = (password: string) => {
    // Regular expressions for password strength
    const strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    const mediumRegex = /^(?=.*[a-zA-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{6,}$/;

    if (strongRegex.test(password)) {
      return 'strong';
    } else if (mediumRegex.test(password)) {
      return 'medium';
    } else {
      return 'weak';
    }
  };

  /**
   * Validates the email field.
   */
  const validateEmailField = () => {
    if (!validateEmail(email)) {
      setEmailError('Invalid email');
    } else {
      setEmailError('');
    }
    validateForm();
  };

  /**
   * Validates the password field and sets the password error if the password is too weak.
   * Also calls the validateForm function.
   */
  const validatePasswordField = () => {
    const passwordStrength = validatePasswordStrength(password);
    if (passwordStrength === 'weak') {
      setPasswordError('Password is too weak');
    } else {
      setPasswordError('');
    }
    validateForm();
  };

  /**
   * Validates the confirm password field and sets the error message if the passwords do not match.
   * Also triggers the form validation.
   */
  const validateConfirmPasswordField = () => {
    if (password !== confirmpassword) {
      setConfirmPasswordError('Passwords do not match');
    } else {
      setConfirmPasswordError('');
    }
    validateForm();
  };

  /**
   * Validates the form inputs for creating a user.
   *
   * @returns {void}
   */
  const validateForm = () => {
    if (validateEmail(email) && validatePasswordStrength(password) === 'strong' && password === confirmpassword) {
      setFormValid(true);
    } else {
      setFormValid(false);
    }
  };

  /**
   * Checks if the password is strong.
   *
   * A strong password must meet the following criteria:
   * - At least 8 characters long
   * - Contains at least one lowercase letter
   * - Contains at least one uppercase letter
   * - Contains at least one digit
   * - Contains at least one special character (@, $, !, %, *, ?, &)
   *
   * @returns {boolean} Returns true if the password is strong, otherwise false.
   */
  const isPasswordStrong = () => {
    const strongRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return strongRegex.test(password);
  };

  return (
    <>
      <Toast ref={toast} />
      <Helmet>
        <title>Create New User</title>
      </Helmet>

      <Container>
        <Typography
          variant="h4"
          mb={3}
          mt={4}
          sx={{
            color: theme.palette.mode === 'dark' ? '#C7C9C7' : '#333f48',
          }}
        >
          Add New User
        </Typography>
        <Card sx={{ p: 2 }}>
          <div className="card flex justify-content-center">
            <div style={{ display: 'flex', gap: '20px' }}>
              <FormControl sx={{ m: 1, flex: 1 }}>
                <label htmlFor="projectname" style={{ fontWeight: 'bold' }}>
                  Select Department
                </label>
                <Select
                  labelId="demo-simple-select-autowidth-label"
                  id="demo-simple-select-autowidth"
                  value={selectedDepartment}
                  onChange={handleChange}
                  onBlur={validateDepartment}
                  error={!!departmentError}
                  label="Department"
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {departmentName.map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ m: 1, flex: 1 }}>
                <label htmlFor="projectname" style={{ fontWeight: 'bold' }}>
                  Select Role
                </label>
                <Select
                  labelId="demo-simple-select-autowidth-label"
                  id="demo-simple-select-autowidth"
                  value={selectedRole}
                  onChange={handleChangeRole}
                  onBlur={validateRole}
                  error={!!roleError}
                  label="Role"
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {role.map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <br />
              <FormControl sx={{ m: 1, flex: 1 }}>
                <label htmlFor="selectproject" style={{ fontWeight: 'bold' }}>
                  Select Projects
                </label>

                <Select
                  labelId="demo-multiple-chip-label"
                  id="demo-multiple-chip"
                  multiple
                  value={ProjectName}
                  onChange={handleProjectChange}
                  // onBlur={() => validateProjects()}
                  error={!!projectsError}
                  input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                  // @ts-ignore
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {/* @ts-ignore */}
                      {selected.map((value) => (
                        <Chip key={value} label={value} />
                      ))}
                    </Box>
                  )}
                  MenuProps={MenuProps}
                >
                  {projectsDetails.map((item) => (
                    // @ts-ignore
                    <MenuItem key={item.label} value={item.label} style={getStyles(item.label, ProjectName, theme)}>
                      {/* @ts-ignore */}
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
                {projectsError && (
                  <Typography variant="body2" color="error">
                    {projectsError}
                  </Typography>
                )}
              </FormControl>
            </div>
          </div>

          <br />
          <div className="card flex justify-content-center">
            <div style={{ display: 'flex', gap: '20px' }}>
              <FormControl sx={{ m: 1, flex: 1 }}>
                <label htmlFor="username" style={{ fontWeight: 'bold' }}>
                  Full Name
                </label>
                <TextField
                  id="username"
                  value={newuserName}
                  label="Enter Full Name"
                  variant="outlined"
                  onBlur={validateUserName}
                  error={!!usernameError}
                  helperText={usernameError}
                  // @ts-ignore
                  onChange={(e) => setNewUserName(e.target.value)}
                />
              </FormControl>
              <br />
              <br />
              <FormControl sx={{ m: 1, flex: 1 }}>
                <label htmlFor="email" style={{ fontWeight: 'bold' }}>
                  Email ID
                </label>
                <TextField
                  id="email"
                  value={email}
                  label="Official Email ID"
                  variant="outlined"
                  onBlur={validateEmailField}
                  error={!!emailError}
                  helperText={emailError}
                  // @ts-ignore
                  onChange={(e) => setEmail(e.target.value)}
                />
              </FormControl>
            </div>
          </div>
          <br />
          <div className="card flex justify-content-center">
            <div style={{ display: 'flex', gap: '20px' }}>
              <FormControl sx={{ m: 1, flex: 1 }}>
                <label htmlFor="password" style={{ fontWeight: 'bold' }}>
                  Password
                </label>
                <TextField
                  id="password"
                  value={password}
                  label="Password"
                  variant="outlined"
                  type={showPassword ? 'text' : 'password'}
                  onBlur={validatePasswordField}
                  error={!!passwordError}
                  helperText={
                    <>
                      {passwordError && (
                        <Typography variant="body2" color="error">
                          {passwordError}
                        </Typography>
                      )}
                      <Typography variant="body2" color="textSecondary" className="font-medium">
                        Password must:
                        <ul style={{ paddingLeft: '20px' }}>
                          <li style={{ color: isPasswordStrong() ? green[500] : undefined }} className="font-medium">
                            {isPasswordStrong() ? '\u2713' : '\u2718'} Be at least 8 characters long
                          </li>
                          <li style={{ color: isPasswordStrong() ? green[500] : undefined }} className="font-medium">
                            {isPasswordStrong() ? '\u2713' : '\u2718'} Contain at least one uppercase letter
                          </li>
                          <li style={{ color: isPasswordStrong() ? green[500] : undefined }} className="font-medium">
                            {isPasswordStrong() ? '\u2713' : '\u2718'} Contain at least one lowercase letter
                          </li>
                          <li style={{ color: isPasswordStrong() ? green[500] : undefined }} className="font-medium">
                            {isPasswordStrong() ? '\u2713' : '\u2718'} Contain at least one number
                          </li>
                          <li style={{ color: isPasswordStrong() ? green[500] : undefined }} className="font-medium">
                            {isPasswordStrong() ? '\u2713' : '\u2718'} Contain at least one special character
                          </li>
                        </ul>
                      </Typography>
                    </>
                  }
                  // @ts-ignore
                  onChange={(e) => setPassword(e.target.value)}
                  InputProps={{
                    // Toggle password visibility
                    endAdornment: (
                      <InputAdornment position="end">
                        <InputAdornment position="end">
                          {isPasswordStrong() && <CheckCircleOutlineIcon style={{ color: 'green' }} />}
                        </InputAdornment>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>
              <br />
              <br />
              <FormControl sx={{ m: 1, flex: 1 }}>
                <label htmlFor="confirmpassword" style={{ fontWeight: 'bold' }}>
                  Confirm Password
                </label>
                <TextField
                  id="confirmpassword"
                  value={confirmpassword}
                  label="Password"
                  variant="outlined"
                  type="password"
                  onBlur={validateConfirmPasswordField}
                  error={!!confirmPasswordError}
                  helperText={confirmPasswordError}
                  // @ts-ignore
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </FormControl>
            </div>
          </div>
          <br />

          <FormControl sx={{ m: 1, minWidth: 250 }}>
            <div>
              <Stack direction="row" spacing={2}>
                <Button
                  variant="contained"
                  endIcon={<SendIcon />}
                  size="large"
                  onClick={async () => await createUser()}
                  disabled={!formValid}
                  className="primary-btn"
                >
                  Create
                </Button>
                <Link to="/dashboard/user">
                  <Button variant="contained" size="large" className="primary-btn">
                    Back
                  </Button>
                </Link>
              </Stack>
            </div>
          </FormControl>
        </Card>
      </Container>
    </>
  );
}
